import React, { View } from "react-native";
import { AdminContainer } from "../container";
import {
    Alert,
    Button,
    Card,
    Headline,
    Loading,
    Spacer,
    StyleFunction,
    useThemedStyle,
} from "@venuepos/react-common";
import { useTranslation } from "locales";
import { useIntegrationsOfTypeQuery } from "graphql-sdk";

export function ExportsScreen({ navigation }) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);

    const { data, loading, error } = useIntegrationsOfTypeQuery({
        variables: {
            type: "FISKALY",
        },
        fetchPolicy: "no-cache",
    });

    return (
        <AdminContainer>
            <Headline size="h1">
                {t("backoffice.exports.headline", "Export financial reports")}
            </Headline>
            <View style={styles.container}>
                <Card style={styles.card}>
                    <View>
                        <Card.Title>
                            {t(
                                "backoffice.exports.saft.headline",
                                "Export SAF-T report"
                            )}
                        </Card.Title>
                        <Card.Body>
                            {t(
                                "backoffice.exports.saft.description",
                                "The Danish tax authorities may request a SAF-T report. This is the place to handle this."
                            )}
                        </Card.Body>
                    </View>
                    <Card.Actions>
                        <Button
                            onPress={() => navigation.navigate("SAFT_EXPORT")}
                        >
                            {t(
                                "backoffice.exports.saft.button",
                                "SAF-T Export"
                            )}
                        </Button>
                    </Card.Actions>
                </Card>
                <Card style={styles.card}>
                    <View>
                        <Card.Title>
                            {t(
                                "backoffice.exports.dsfinvk.headline",
                                "Export DSFinV-K report"
                            )}
                        </Card.Title>
                        <Card.Body>
                            {data?.integrationsOfType.data.length === 1
                                ? t(
                                      "backoffice.exports.dsfinvk.description",
                                      "The German tax authorities may request a DSFinV-K report. This is the place to handle this."
                                  )
                                : t(
                                      "backoffice.exports.dsfinvk.no_integration_description",
                                      "The German tax authorities may request a DSFinV-K report.\n\nThis merchant does not have an integration with Fiskaly, so this is not needed."
                                  )}
                        </Card.Body>
                    </View>

                    {error ? (
                        <Alert type="error">
                            {t(
                                "backoffice.error.from_server",
                                "There was an error: {{errorText}}",
                                {
                                    errorText: error.message,
                                }
                            )}
                        </Alert>
                    ) : loading ? (
                        <Loading />
                    ) : (
                        <Card.Actions>
                            <Button
                                onPress={() =>
                                    navigation.navigate("DSFINVK_EXPORT")
                                }
                                disabled={
                                    data?.integrationsOfType.data.length !== 1
                                }
                            >
                                {t(
                                    "backoffice.exports.dsfinvk.button",
                                    "DSFinV-K Export"
                                )}
                            </Button>
                        </Card.Actions>
                    )}
                </Card>
            </View>
            <Spacer />
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        ...theme.styles.row,
        flex: 1,
        gap: theme.spacingScale,
    },
    card: {
        flex: 1,
        justifyContent: "space-between",
    },
});
